<template>
    <c-dialog ref="dialog" title="派单规则详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.rule_name" class="m-detail-tag flex-center-cross">
                <label>{{detailData.rule_name}}</label>
                <c-state :value="detailData.is_enable == 1 ? 1 : 2" tag></c-state>
            </div>
        </template>

        <div class="m-detail-box">
            <c-title>基本信息</c-title>
            <c-detail >
                <c-detail-item label="规则编码">
                    {{detailData.rule_code}}
                </c-detail-item>
                <c-detail-item label="规则名称">
                    {{detailData.rule_name}}
                </c-detail-item>
                <c-detail-item label="规则类型">
                    {{detailData.rule_type == 1 ? '筛选规则' : '排序规则'}}
                </c-detail-item>
                <c-detail-item label="执行顺序">
                    {{detailData.rule_order}}
                </c-detail-item>
                <c-detail-item label="备注">
                    {{detailData.rule_content}}
                </c-detail-item>
                <c-detail-item v-if="detailData.rule_type == 2" label="规则权重">
                    {{detailData.weight*100}}%
                </c-detail-item>
                <c-detail-item label="状态">
                    {{detailData.is_enable == 1 ? '启用' : '禁用'}}
                </c-detail-item>
            </c-detail>

            <c-title v-if="detailData.config_params">配置参数</c-title>
            <c-detail v-if="detailData.config_params" column="1">
                <!-- CORE_CIRCLE_FILTER: 核心圈工程师筛选 -->
                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'CORE_CIRCLE_FILTER'">
                    默认按地图开车导航测算距离计算
                </c-detail-item>
                <c-detail-item label="核心圈距离" v-if="detailData.rule_code === 'CORE_CIRCLE_FILTER'">
                    {{detailData.config_params_map.coreCircleKm || '暂无配置'}} km
                </c-detail-item>

                <!-- CORE_CIRCLE_FILTER: 核心圈工程师筛选 -->
                <c-detail-item label="必备技能工程师筛选配置" v-if="detailData.rule_code === 'SKILLS_FILTER'">
                    暂无配置参数
                </c-detail-item>

                <!-- LEAVE_FILTER: 在岗工程师筛选 -->
                <c-detail-item label="在岗工程师筛选配置" v-if="detailData.rule_code === 'LEAVE_FILTER'">
                    暂无配置参数
                </c-detail-item>
                <!-- WORK_TIME_FILTER: 服务时间匹配筛选 -->
                <c-detail-item label="服务时间匹配筛选配置" v-if="detailData.rule_code === 'WORK_TIME_FILTER'">
                    暂无配置参数
                </c-detail-item>

                <!-- OUTLET_FILTER: 网点工程师筛选 -->
                <c-detail-item label="服务时间匹配筛选配置" v-if="detailData.rule_code === 'OUTLET_FILTER'">
                    暂无配置参数
                </c-detail-item>

                <c-detail-item label="标准工时" v-if="detailData.rule_code === 'WORK_HOURS_SORT'">
                    {{detailData.config_params_map.daily_standard_hours || '暂无配置'}} 小时/天
                </c-detail-item>
                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'WORK_HOURS_SORT'">
                    <p style="margin-bottom: 8px;"><b>标准工时 = 日标准工时 × 工作日天数。</b>例如：标准工时为8小时/天，到2026.04.09派单时已上班工作日天数为5天，则标准工时为40小时。</p>
                    <p style="margin-bottom: 8px;"><b>实际服务工时 = 根据工单服务打卡记录，计算工程师实际服务工时数。</b>例如：2026.04.01打卡工时9小时，2026.04.02打卡工时8小时，2026.04.03打卡工时10小时，
                        2026.04.07请假， 2026.04.08无服务工单，则实际服务工时为27小时。</p>
                    <p style="margin-bottom: 8px;">
                        <b>工时偏差= 标准工时 - 实际服务工时。</b>例如：标准工时为40小时，实际服务工时为27小时，则工时偏差为13小时。<br/>
                        <b>偏差为正：</b>代表员工没干满、有空闲，偏差越大（越闲），越优先派单。<br/>
                        <b>偏差为0：</b>代表员工工作量正常<br/>
                        <b>偏差为负：</b>代表员工加班多、超负荷，偏差越大（越忙），越不优先派单<br/>
                    </p>
                </c-detail-item>
                <span v-if="detailData.rule_code === 'WORK_HOURS_SORT'" class="custom-table-title">
                    工时偏差表
                </span>
                <c-table v-if="detailData.rule_code === 'WORK_HOURS_SORT'" :data="detailData.config_params_map.work_hours_levels" :paging="false" border>
                    <c-table-column
                            label="员工状态"
                            width="100"
                            name="label"
                    >
                    </c-table-column>
                    <c-table-column
                            label="偏差工时"
                            width="100"
                            name="max_diff"
                    >
                        <template #default="{data}">
                            <span v-if="data.max_diff >= 0" style="color: #52c41a;">{{ data.max_diff }}，比标准工时少【{{ data.max_diff }}】小时以上</span>
                            <span v-else-if="data.max_diff < 0" style="color: #ff4d4f;">{{ data.max_diff }}，比标准工时多【{{ 0 - data.max_diff }}】小时以内</span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="优先派单值"
                            width="100"
                            name="score"
                    >
                    </c-table-column>
                </c-table>

                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'LOW_LOAD_SORT'">
                    处理中工单数越少（负载越低），越优先派单
                </c-detail-item>
                <!-- LOW_LOAD_SORT: 负载低优先 -->
                <c-detail-item label="默认最大工单数" v-if="detailData.rule_code === 'LOW_LOAD_SORT'">
                    {{detailData.config_params_map.default_max_order_count || '暂无配置'}} 单
                </c-detail-item>

                <span v-if="detailData.rule_code === 'LOW_LOAD_SORT'" class="custom-table-title">
                    负载等级表
                </span>
                <c-table v-if="detailData.rule_code === 'LOW_LOAD_SORT'" :data="detailData.config_params_map.load_levels" :paging="false" border>
                    <c-table-column
                            label="负载等级"
                            width="100"
                            name="label"
                    >
                    </c-table-column>
                    <c-table-column
                            label="最大工单数"
                            width="100"
                            name="max_count"
                    >
                        <template #default="{data}">
                            <span :style="{color: data.max_count === -1 ? '#ff4d4f' : '#52c41a'}">
                                {{ data.max_count === -1 ? '无限制' : data.max_count + ' 单' }}
                            </span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="优先派单值"
                            width="100"
                            name="score"
                    >
                    </c-table-column>
                </c-table>

                <!-- NEAR_DISTANCE_SORT: 距离近优先 -->
                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'NEAR_DISTANCE_SORT'">
                    与工单位置距离越近，越优先派单
                </c-detail-item>
                <span v-if="detailData.rule_code === 'NEAR_DISTANCE_SORT'" class="custom-table-title">
                    距离等级表
                </span>
                <c-table v-if="detailData.rule_code === 'NEAR_DISTANCE_SORT'" :data="detailData.config_params_map.distance_levels" :paging="false" border>
                    <c-table-column
                            label="距离等级"
                            width="100"
                            name="label"
                    >
                    </c-table-column>
                    <c-table-column
                            label="最大距离"
                            width="100"
                            name="max_distance"
                    >
                        <template #default="{data}">
                            <span :style="{color: data.max_distance === -1 ? '#ff4d4f' : '#1890ff'}">
                                {{ data.max_distance === -1 ? '无限制' : '≤' + data.max_distance + ' km' }}
                            </span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="优先派单值"
                            width="100"
                            name="score"
                    >
                    </c-table-column>
                </c-table>

                <!-- CUSTOMER_RATING_SORT: 用户评价高优先 -->
                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'CUSTOMER_RATING_SORT'">
                    工程师用户评价越好，越优先派单。<br>
                    工程师评价分= 所有工单评价分之和/工单数。工程师无评价或评价数不足最小评价数，则按默认评价分派单。
                </c-detail-item>
                <c-detail-item label="默认评价分" v-if="detailData.rule_code === 'CUSTOMER_RATING_SORT'">
                    {{detailData.config_params_map.default_rating || '暂无配置'}} 分
                </c-detail-item>
                <c-detail-item label="最小评价数" v-if="detailData.rule_code === 'CUSTOMER_RATING_SORT'">
                    {{detailData.config_params_map.min_rating_count || '暂无配置'}} 条
                </c-detail-item>
                <span v-if="detailData.rule_code === 'CUSTOMER_RATING_SORT'" class="custom-table-title">
                    评价等级表
                </span>
                <c-table v-if="detailData.rule_code === 'CUSTOMER_RATING_SORT'" :data="detailData.config_params_map.rating_levels" :paging="false" border>
                    <c-table-column
                            label="评价等级"
                            width="100"
                            name="label"
                    >
                    </c-table-column>
                    <c-table-column
                            label="最低评价分"
                            width="100"
                            name="min_rating"
                    >
                        <template #default="{data}">
                            <span :style="{color: data.min_rating === -1 ? '#ff4d4f' : data.min_rating >= 4.5 ? '#52c41a' : '#faad14'}">
                                {{ data.min_rating === -1 ? '无限制' : '≥' + data.min_rating + '分' }}
                            </span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="优先派单值"
                            width="100"
                            name="score"
                    >
                    </c-table-column>
                </c-table>


                <!-- REJECT_ORDER_SORT: 拒单数少优先 -->
                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'REJECT_ORDER_SORT'">
                    工程师最近拒单数越少，越优先派单。<br>
                </c-detail-item>
                <c-detail-item label="数据统计范围" v-if="detailData.rule_code === 'REJECT_ORDER_SORT'">
                    最近{{detailData.config_params_map.data_valid_days || '暂无配置'}} 天
                </c-detail-item>

                <span v-if="detailData.rule_code === 'REJECT_ORDER_SORT'" class="custom-table-title">
                    拒单等级表
                </span>
                <c-table v-if="detailData.rule_code === 'REJECT_ORDER_SORT'" :data="detailData.config_params_map.count_levels" :paging="false" border>
                    <c-table-column
                            label="拒单等级"
                            width="100"
                            name="label"
                    >
                    </c-table-column>
                    <c-table-column
                            label="最大拒单数量"
                            width="100"
                            name="max_return_count"
                    >
                        <template #default="{data}">
                            <span :style="{color: data.max_return_count === -1 ? '#ff4d4f' : data.max_return_count <= 1 ? '#52c41a' : '#faad14'}">
                                {{ data.max_return_count === -1 ? '无限制' : '≤' + data.max_return_count + '单' }}
                            </span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="优先派单值"
                            width="100"
                            name="score"
                    >
                    </c-table-column>
                </c-table>

                <!-- QUALITY_IMPACT_SORT: 质量影响（客诉）少优先 -->
                <c-detail-item label="计算说明" v-if="detailData.rule_code === 'QUALITY_IMPACT_SORT'">
                    工程师最近质量影响（客诉）数越少，越优先派单。<br>
                </c-detail-item>
                <c-detail-item label="数据统计范围" v-if="detailData.rule_code === 'QUALITY_IMPACT_SORT'">
                    最近{{detailData.config_params_map.tag_valid_days || '暂无配置'}} 天
                </c-detail-item>

                <span v-if="detailData.rule_code === 'QUALITY_IMPACT_SORT'" class="custom-table-title">
                    质量影响（客诉）等级表
                </span>
                <c-table v-if="detailData.rule_code === 'QUALITY_IMPACT_SORT'" :data="detailData.config_params_map.count_levels" :paging="false" border>
                    <c-table-column
                            label="客诉等级"
                            width="100"
                            name="label"
                    >
                    </c-table-column>
                    <c-table-column
                            label="最大客诉数量"
                            width="100"
                            name="max_complaint_count"
                    >
                        <template #default="{data}">
                            <span :style="{color: data.max_complaint_count === -1 ? '#ff4d4f' : data.max_complaint_count < 1 ? '#52c41a' : '#faad14'}">
                                {{ data.max_complaint_count === -1 ? '无限制' : '≤' + data.max_complaint_count + '单' }}
                            </span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="优先派单值"
                            width="100"
                            name="score"
                    >
                    </c-table-column>
                </c-table>
            </c-detail>

<!--            <c-title>系统信息</c-title>-->
<!--            <c-detail column="2">-->
<!--                <c-detail-item label="创建日期">-->
<!--                    {{detailData.create_date}}-->
<!--                </c-detail-item>-->
<!--                <c-detail-item label="更新日期">-->
<!--                    {{detailData.update_date}}-->
<!--                </c-detail-item>-->
<!--            </c-detail>-->
        </div>
    </c-dialog>
</template>

<script>

import CTips from "@/components/public/tips.vue";

export default {
    name: 'dispatchRuleDetail',

    components: {
        CTips

    },

    props: {
        id: [String, Number]
    },

    computed: {

    },

    data() {
        return {
            detailData: {
                config_params_map: {},
            }
        }
    },

    methods: {
        open() {
            this.request({
                url: '/dispatch/rule/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
>>> .custom-table-title {
    font-size: 14px;
    font-weight: 600;

    padding: 8px 5px;
    border-left: 1px solid #ddd;
    border-radius: 2px;
    display: block;
}
</style>
